import { motion } from 'framer-motion';

export default function StatsSection({ section }) {
  const { title, data = {} } = section;
  const stats = data.stats || [];
  if (stats.length === 0) return null;

  return (
    <section className="py-16 sm:py-20" style={{ background: 'hsl(var(--bg-paper-2))' }} data-testid="section-stats">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
        {title && (
          <motion.h2
            className="font-display text-2xl sm:text-3xl font-medium tracking-[-0.015em] text-ink mb-10 text-center"
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35 }}
          >
            {title}
          </motion.h2>
        )}
        <div className={`grid gap-8 ${
          stats.length <= 3 ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-2 sm:grid-cols-4'
        }`}>
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              className="text-center"
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.08 }}
            >
              <div className="font-display text-3xl sm:text-4xl font-medium text-ink mb-1">{stat.value}</div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
